import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AbstractControl, ValidationErrors } from '@angular/forms';

// custom validator to check that two fields match
export function MatchValidator(controlName: string, matchingControlName: string) {
  return (formGroup: UntypedFormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.matchPassword) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ matchPassword: true });
    } else {
      matchingControl.setErrors(null);
    }
  }
}

// custom validator to check that two fields match
export function ValidateTrimValues(control: AbstractControl): ValidationErrors | null {
    if (control.value?.length && String(control.value).trim() === '') {
        return { required: true };
    }
    return null;
}
